import { paymentsClient } from "@/shared/rpc/clients";
import type { PaymentMethodMessage } from "@cronika/proto/common/payment_pb";
import { makeAutoObservable, runInAction } from "mobx";

class QuickDepositStore {
  methods: PaymentMethodMessage[] = [];
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async load(countryCode: string) {
    runInAction(() => {
      this.loading = true;
    });
    try {
      const res = await paymentsClient.listPaymentMethods({
        direction: 1, // PaymentDirection.DEPOSIT
        country: countryCode.toLowerCase(),
      });

      const allActive = (res.data ?? []).filter((m) => m.isActive !== false);
      const recent = allActive.filter((m) => m.categories.includes("recent")).slice(0, 3);
      const recentIds = new Set(recent.map((m) => m.id));
      const popular = allActive
        .filter((m) => m.categories.includes("popular") && !recentIds.has(m.id))
        .slice(0, 5 - recent.length);
      const result = [...recent, ...popular];

      runInAction(() => {
        this.methods = result;
        this.loading = false;
      });
    } catch {
      runInAction(() => {
        this.methods = [];
        this.loading = false;
      });
    }
  }

  reset() {
    this.methods = [];
  }
}

export const quickDepositStore = new QuickDepositStore();
